module.exports = function getResource(label, vars = []) {
    let resources = {
        edit: 'Modifier'
    };
    return resources[label];
};
